import debug from 'bows';

let log = debug('analytics');

export const trackEvent = function( category, action, label ) {
	let track = ( callback ) => {
		// Debugging
		log('Track Event:', { category: category, action: action, label: label });

		if ( location.host !== 'www.whitehouse.gov' ) {
			log( `Track Event Request not sent due to location.host = ${location.host}` );
			return callback( 'TrackEvent Successful but not sent.' );
		}

		if ( typeof window.gtag === 'function' ) { // gtag.js
			window.gtag('event', action, {
				'event_category': category,
				'event_action': action, // Event name is default, this is redundant
				'event_label': label,
				'event_callback': () => callback('gtag event sent!')
			});
		} else if ( typeof window.ga === 'function' ) { // analytics.js
			// Resolve on hitCallback
			window.ga('send', 'event', category, action, label, {
				hitCallback: () => callback('ga event sent!')
			});
		} else {
			// No handler found!
			return callback('No analytics tracker exists!');
		}
	}

	let trackPromise;
	if ( ! window.Promise ) {
		log('Browser does not support promises!');
		track(() => {}); // noop
		// Create fake promise
		trackPromise = {
			then: ( callback ) => {
				// insta-resolve
				if ( typeof callback === 'function' ) {
					callback();
				}
			}
		}
	} else {
		// This promise is ALWAYS resolved to avoid unhandled promise rejection
		trackPromise = new Promise((resolve, reject) => {
			track(resolve);

			// Reject if it takes more than 1s
			setTimeout(() => resolve('Analytics event timed out after 1s'), 1000);
		});
	}

	return trackPromise;
}

/**
 * Callback handler for mousedown and click events which forwards to a URL (if needed)
 *
 * Expects e.data property containing {
 *   category*
 *   action (optional) - defaults to element href
 *   label (optional) - defaults to element text
 *   href (optional): where to forward - defaults to element href
 * }
 *
 * @param Event e
 */
export const trackAllClicks = function ( e ) {
	// Deep copy to avoid reference issues
	let data = JSON.parse( JSON.stringify( e.data ) );

	let handler = () => {
		// Track event
		return trackEvent( data.category, data.action, data.label ).then( ( val ) => {
			// Debugging
			log('Event message:', val);
		} );
	};

	// Set defaults
	if ( ! data.action && e.currentTarget && e.currentTarget.href ) {
		data.action = e.currentTarget.href;
	} else if ( ! data.action && e.type ) {
		data.action = e.type;
	}
	if ( ! data.label && e.currentTarget && e.currentTarget.textContent ) {
		data.label = e.currentTarget.textContent.trim();
	} else if ( ! data.label ) {
		data.label = document.title;
	}
	if ( ! data.href && e.currentTarget && e.currentTarget.href ) {
		data.href = e.currentTarget.href;
	}

	switch ( e.type ) {
		case 'click':
			if ( typeof e.isDefaultPrevented === 'function' && e.isDefaultPrevented() ) {
				log('Default prevented on click');
				handler();
			} else if ( ! data.href || data.href === '#' || data.href.replace( window.location.href, '' ).length === 0 ) {
				log('No href on click');
				handler();
			} else if ( e.currentTarget && 'javascript:' === e.currentTarget.protocol ) {
				log('JavaScript link on click');
				handler();
			} else if ( e.currentTarget && e.currentTarget.target && ! e.currentTarget.target.match( /^_(self|parent|top)$/i ) ) {
				log('Target ' + e.currentTarget.target + ' on click');
				handler();
			} else if ( e.ctrlKey || e.shiftKey || e.which == 2 ) { // e.which == 2 for jquery-triggered middle clicks
				log('Ctrl/shift/middle click');
				handler();
			} else if ( data.href && typeof e.preventDefault === 'function' ) {
				log('Delaying click', data.href);
				// Special handling
				e.preventDefault();
				// Change the window location
				handler().then( () => window.location.href = data.href );
			} else {
				log('Unknown click event', e);
				handler();
			}
		break;
		case 'mousedown':
			if ( e.button === 1 ) { // Only track middle clicks
				log('Middle click');
				handler();
			}
		break;
		default:
			log('Unknown event', e.type);
			handler();
			return;
		break;
	}
}

export const trackPageview = function() {
	let track = ( callback ) => {
		// Debugging
		log('Track Pageview');

		if ( location.host !== 'www.whitehouse.gov' ) {
			log( `Track Pageview Request not sent due to location.host = ${location.host}` );
			return callback( 'TrackPageview Successful but not sent.' );
		}

		if ( typeof window.gtag === 'function' && window.gtag_id ) { // gtag.js
			window.gtag('config', window.gtag_id);
			return callback('gtag pageview sent!');
		} else if ( typeof window.ga === 'function' ) { // analytics.js
			window.ga('send', 'pageview');
			return callback('ga pageview sent!');
		} else {
			// No handler found!
			return callback('No analytics tracker exists!');
		}
	}

	let trackPromise;
	if ( ! window.Promise ) {
		log('Browser does not support promises!');
		track(() => {}); // noop
		// Create fake promise
		trackPromise = {
			then: ( callback ) => {
				// insta-resolve
				if ( typeof callback === 'function' ) {
					callback();
				}
			}
		}
	} else {
		// This promise is ALWAYS resolved to avoid unhandled promise rejection
		trackPromise = new Promise((resolve, reject) => {
			track(resolve);

			// Reject if it takes more than 1s
			setTimeout(() => resolve('Analytics event timed out after 1s'), 1000);
		});
	}

	return trackPromise;
}
